import React, { useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { HelperCards, Href, LearnMore } from "../../../../../Constant";
import { H6, LI } from "../../../../../AbstractElements";

export const HelperCart = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  return (
    <div className="btn-group">
      <Dropdown isOpen={open} toggle={toggle}>
        <DropdownToggle caret color="secondary" className="text-white">
          {HelperCards}
        </DropdownToggle>
        <DropdownMenu className="dropdown-block p-3 dark-form">
          <LI>
            <H6 className="fs-6 fw-bold pb-2">{LearnMore}</H6>
            <DropdownItem className="dropdown-item p-0 helper-truncate" href={Href}>There is a lot of information available here</DropdownItem>
          </LI>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};
